import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Report } from 'src/app/dashboard/admin/report/report';
import { LanguageService } from 'src/app/shared/services/language.service';
import { InvoiceMonthlySalesReportService } from '../../services/invoice-monthly-sales-report.service';

@Component({
  selector: 'app-monthly-invoice',
  templateUrl: './monthly-invoice.component.html',
  styleUrls: ['./monthly-invoice.component.scss']
})
export class MonthlyInvoiceComponent implements OnInit {
  reportName = "Invoice Monthly Sales";
  tableColumns: string[] = [
    'date',
    'sales',
    'fees',
    'vat',
  ];
  addedFilters = [];

  displayTableColumns: object = {};
  oldTickets: object = {};
  curuntTicket: any[] = [];
  totalNumberOfRecords: number = 0;
  invoiceSalesData: any[] = [];
  filterField: any[] = [];

  requestBody: Report = {};
  loading = false;

  constructor(
    public invoiceSalesReport: InvoiceMonthlySalesReportService,
    private translate: TranslateService,
    private languageService: LanguageService
  ) { }

  async ngOnInit() {
    if (localStorage.getItem("language")) {
      if (localStorage.getItem("language") === "ar") {
        this.translate.use('ar');
      } else {
        this.translate.use('en');
      }
    } else {
      this.translate.use('en');
    }

    this.updateContent();

    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
      this.updateContent();
    });

    this.invoiceSalesReport.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable(true);
  }

  updateContent() {
    const lang = this.translate.currentLang;
    if (lang === 'ar') {
      this.reportName = "المبيعات الشهرية ";
      this.displayTableColumns = {
        'date': 'التاريخ',
        'sales': 'مبيعات',
        'fees': 'مصاريف',
        'vat': 'ضريبة',
      };
    } else {
      this.reportName = "Invoice Monthly Sales";
      this.displayTableColumns = {
        'date': 'Date',
        'sales': 'Business Sales',
        'fees': 'Business Fees',
        'vat': 'Business Vat',
      };
    }

    this.updateFilterFields();
  }

  private updateFilterFields() {
    const isAr = this.translate.currentLang === 'ar';
    this.filterField = [{
      filterFieldName: "date",
      filterDisplayName: isAr ? "تاريخ" : "Date",
      defaultValue: "",
      filterOptions: [
        { key: isAr ? "إظهار الكل" : "Show All", value: null },
        ...this.addedFilters
      ]
    }];
  }

  actionsCB(object: any) {
    console.log("hey from the resport", object);
  }

  async filter($event: any) {
    if ($event && Object.keys($event).length) {
      this.requestBody.filterOptions = $event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.invoiceSalesReport.loader().subscribe((val: any) => (this.loading = val));
  }

  async paginate($event: any) {
    this.requestBody.paginationOptions = {
      start: $event.pageIndex * $event.pageSize,
      limit: $event.pageSize
    };
    this.updateTable();
    this.invoiceSalesReport.loader().subscribe((val: any) => (this.loading = val));
  }

  async searchChange($event: any) {
    if ($event) {
      this.requestBody.searchOptions = {
        searchKey: $event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.invoiceSalesReport.loader().subscribe((val: any) => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.invoiceSalesReport.loader().subscribe((val: any) => (this.loading = val));
  }

  async updateTable(initLoading = false) {
    this.invoiceSalesReport.activateLoader();
    this.invoiceSalesReport.setParams(this.requestBody);
    const report = await this.invoiceSalesReport.make();
    this.invoiceSalesData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;

    if (report.filters) {
      if (initLoading) {
        const mappedFilters = report.filters.map((res: string) => {
          return { key: res, value: res }
        });
        this.addedFilters = mappedFilters;

        this.updateFilterFields();
      }
    }
  }
}
